import { render, staticRenderFns } from "./SecondLevelAbout.vue?vue&type=template&id=18092b5c&scoped=true"
import script from "./SecondLevelAbout.vue?vue&type=script&lang=js"
export * from "./SecondLevelAbout.vue?vue&type=script&lang=js"
import style0 from "./SecondLevelAbout.vue?vue&type=style&index=0&id=18092b5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18092b5c",
  null
  
)

export default component.exports